import { Box, SxProps } from '@mui/material';
import dayjs from 'dayjs';
import React, { useMemo } from 'react';
import { headingFontBold, vars } from '../../../Theme';
import { parseDate } from '../../../util/DataUtils';

export const getRelativeLabel = (
    value: string | number,
    isDate: boolean,
): { label: string; dateRelative: number } => {
    let label: string;
    let dateRelative: number;
    if (!isDate || !value) {
        label = '';
    } else {
        label = typeof value === 'string' ? parseDate(+value.split('|')[0]) : parseDate(value);
    }

    if (!isDate) {
        dateRelative = isNaN(Number(value)) ? null : Number(value);
    } else {
        dateRelative =
            typeof value === 'string'
                ? Number(value.split('|')[1] || '')
                : dayjs(value).diff(dayjs(), 'days');
    }

    return { label, dateRelative };
};

/**
 * Component that shows a numeric value, styled according to that value.
 */
export default ({ value, isDate }: IDocTableIndicatorProps) => {
    /** Gets the showing label depending of the type. */
    const { label, dateRelative } = useMemo(() => {
        return getRelativeLabel(value, isDate);
    }, [value, isDate]);

    /** Calculate the component's styles. */
    const boxSx: SxProps = useMemo(() => {
        let bgcolor: string = vars.warningYellow;

        if (dateRelative > 0) {
            bgcolor = vars.trafficLightGreen;
        }

        if (dateRelative < 0) {
            bgcolor = vars.red;
        }

        return {
            ...headingFontBold,
            textAlign: 'center',
            lineHeight: '20px',
            color: vars.white,
            borderRadius: 16,
            minWidth: 36,
            fontSize: 12,
            height: 20,
            bgcolor,
            ml: 1,
            px: 1,
        };
    }, [dateRelative]);

    return (
        <>
            {label}
            {value === '' || (typeof(value) === 'number' && Number.isNaN(value)) ? <></> : <Box sx={boxSx}>{dateRelative}</Box>}
        </>
    );
};

export interface IDocTableIndicatorProps {
    /** Value to display. */
    value: number | string;

    /** (Optional) Whether to treat the value as a timestamp. */
    isDate?: boolean;
}
